import { type LucideIcon } from "lucide-react";
import { useRouterState } from "@tanstack/react-router";
import { useMemo } from "react";

interface MenuItem {
  title: string;
  url: string;
  icon: LucideIcon;
  items?: {
    title: string;
    url: string;
  }[];
}

export function useActiveMenu(items: MenuItem[]) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  // Calculate active items whenever pathname or items change
  const activeItems = useMemo(() => {
    return items.map((item) => {
      // Active if pathname matches or is a sub-path (e.g., /customers or /customers/123)
      const isMainActive =
        pathname === item.url || pathname.startsWith(item.url + "/");
      const hasActiveChild =
        item.items?.some(
          (subItem) =>
            pathname === subItem.url || pathname.startsWith(subItem.url + "/")
        ) || false;

      return {
        ...item,
        isActive: isMainActive || hasActiveChild,
        items: item.items?.map((subItem) => ({
          ...subItem,
          isActive:
            pathname === subItem.url || pathname.startsWith(subItem.url + "/"),
        })),
      };
    });
  }, [pathname, items]);

  return {
    activeItems,
  };
}